import React from 'react';
import ReacDOM from 'react-dom';
import { ListBuilderApp } from './renderable-blocks';

ReacDOM.render(
	<ListBuilderApp />,
	document.getElementById( 'list-builder-root' )
)
